import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { SenderIdValidateRequest } from '../interfaces/sender-id-validate-request.interface';
import { SenderIdValidateResponse } from '../interfaces/sender-id-validate-response.interface';
import { SenderIdAuthorisationItem } from '../interfaces/sender-id-authorisation-item.interface';
import { HttpContextTokens, HttpLoggingOptions } from 'common';
import { PublicSearchSenderIdItem } from '../interfaces/public-search-sender-id-item.interface';
import { PublicSearchRegisteredPaItem } from '../interfaces/public-search-registered-pa-item.interface';
import { ThirdPartyAssignmentItem } from '../interfaces/third-party-assignement-item.interface';

const sharedUrl = '/senderidregistry/public';

@Injectable({
  providedIn: 'root',
})
export class PublicApiService {
  private http = inject(HttpClient);

  validateSenderId$(data: SenderIdValidateRequest) {
    const context = new HttpContext();
    const httpLoggingOptions = new HttpLoggingOptions();
    httpLoggingOptions.doNotLog = true;
    context.set(HttpContextTokens.options, httpLoggingOptions);

    return this.http.post<SenderIdValidateResponse>(`${sharedUrl}/sender-id/validate`, data, { context });
  }

  getAllOpasList$() {
    return this.http.get<SenderIdAuthorisationItem[]>(`${sharedUrl}/PAs/available`);
  }

  getSenderIdsSearch$(text: string) {
    return this.http.get<PublicSearchSenderIdItem[]>(`${sharedUrl}/search/sender-id`, { params: { text }});
  }

  getPaSearchList$() {
    return this.http.get<PublicSearchRegisteredPaItem[]>(`${sharedUrl}/search/pa`);
  }

  getAllThirdPartiesList$() {
    return this.http.get<ThirdPartyAssignmentItem[]>(`${sharedUrl}/third-parties/available`);
  }
}
